import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getFreight,
  getParticularPage,
  getNext,
  getPrevious,
  getFreightById,
  createFreight,
  updateFreight,
  handleSearch,
} from "./thunk";

const initialState = {
  freights: [],
  edit: false,
  freight: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingFreight: false,
  loadingNext: false,
  showCreateModal: false,
};

export const freightSlice = createSlice({
  name: "freight",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllFreight: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingFreight = false;
      state.freight = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createFreight.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createFreight.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createFreight.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateFreight.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateFreight.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateFreight.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getFreightById.pending, (state) => {
      state.loading = true;
      state.freight = null;
    });
    builder.addCase(getFreightById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.freight = action.payload.data;
    });
    builder.addCase(getFreightById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.freight = null;
    });
    builder.addMatcher(
      isAnyOf(
        getFreight.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingFreight = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getFreight.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingFreight = false;
        state.freights = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getFreight.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingFreight = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllFreight } = freightSlice.actions;

export default freightSlice.reducer;
